/* Balkan theme — interakcije: mobilni meni, korpa (AJAX), količine, galerija, sort, gate */
(function () {
  'use strict';

  var money = window.Shopify && Shopify.money_format ? Shopify.money_format : '{{amount}} €';

  /* ---- toast ---- */
  var toastEl = document.getElementById('toast');
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  }

  /* ---- mobilni meni ---- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () { nav.classList.toggle('open'); });
    document.addEventListener('click', function (e) {
      if (nav.classList.contains('open') && !nav.contains(e.target) && !navToggle.contains(e.target)) {
        nav.classList.remove('open');
      }
    });
  }

  /* ---- količina (+/-) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var box = btn.closest('.qty-box');
    var input = box && box.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    val += parseInt(btn.getAttribute('data-qty'), 10);
    if (val < parseInt(input.min || 1, 10)) val = parseInt(input.min || 1, 10);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- AJAX dodavanje u korpu ---- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.card-add-form') && !(form.id === 'ProductForm')) return;
    var btn = form.querySelector('[data-add-to-cart]');
    // Product page uses full form submit is fine, but AJAX for nicer UX:
    e.preventDefault();
    var fd = new FormData(form);
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Dodaje se…'; }
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (res.ok) {
          toast('Dodato u korpu ✓');
          refreshCartCount();
        } else {
          toast(res.d && res.d.description ? res.d.description : 'Greška pri dodavanju');
        }
      })
      .catch(function () { toast('Greška u vezi. Pokušaj ponovo.'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Dodaj +'; }
      });
  });

  /* ---- product varijanta -> cena ---- */
  var variantSelect = document.getElementById('VariantSelect');
  var priceEl = document.getElementById('ProductPrice');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var p = opt.getAttribute('data-price');
      if (p) priceEl.innerHTML = '<span class="price">' + p + '</span>';
    });
  }

  /* ---- galerija (thumb -> main) ---- */
  var mainImg = document.getElementById('MainImageTag');
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var full = t.getAttribute('data-full');
      if (full && mainImg) mainImg.src = full;
    });
  });

  /* ---- collection sort ---- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---- cart live qty update ---- */
  document.querySelectorAll('[data-line-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = Array.prototype.indexOf.call(document.querySelectorAll('[data-line-qty]'), input) + 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: parseInt(input.value, 10) || 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---- research gate ---- */
  var gate = document.getElementById('ResearchGate');
  if (gate) {
    try {
      if (!sessionStorage.getItem('bp_gate_ok')) {
        gate.hidden = false;
        var accept = gate.querySelector('[data-gate-accept]');
        if (accept) accept.addEventListener('click', function () {
          sessionStorage.setItem('bp_gate_ok', '1');
          gate.hidden = true;
        });
      }
    } catch (e) { gate.hidden = true; }
  }

  refreshCartCount();
})();
